import { createAction } from '@reduxjs/toolkit';
import { User } from '@internal/api/types';

export const init = createAction<User | null>('user/init');
export const logout = createAction('user/logout');
export const login = createAction<{ user: User; accessToken: string }>('user/login');
export const changeName = createAction<string>('user/changeName');
